import { useMemo } from 'react';
import { api } from '../../../api';
import { useRestStore } from '../useRestStore';

export const useBankAccounts = financeEntityId => {
    const store = useRestStore(
        ['bank-accounts', financeEntityId],
        {
            get: () => api.financeEntities.getBankAccounts(financeEntityId),
            update: (id, item) => api.bankAccounts.update(id, item),
            create: data => api.bankAccounts.create(financeEntityId, data),
            delete: id => api.bankAccounts.delete(id)
        },
        {
            enabled: !!financeEntityId
        }
    );

    return useMemo(() => {
        return {
            bankAccounts: store.data,
            status: store.status,
            updateBankAccount: store.update,
            createBankAccount: store.create,
            deleteBankAccount: store.delete,
            getById: store.getById
        };
    }, [store]);
};
